import { Card } from 'react-bootstrap';
import MainTable from './components/Maintable';

// why
const RegistrationMasterDetails = () => {

  return (
    <Card className='w-100 h-100'>
      <div className='bg-holder bg-card odex-bldetails-img-r' />

      <Card.Body className='p-0'>
        <MainTable />
      </Card.Body>
    </Card>
  );
};

export default RegistrationMasterDetails;
